<template>
  <!--
    离开确认挽留弹窗
    对齐小程序 leave-confirm-modal / registerEntry_tl12
  -->
  <div v-if="visible" class="leave-confirm-modal">
    <div class="leave-confirm-modal__mask"></div>
    <div class="leave-confirm-modal__panel">
      <img class="leave-confirm-modal__bg" :src="resolvedBgSrc" alt="" />
      <div class="leave-confirm-modal__body">
        <span class="leave-confirm-modal__title">{{ title }}</span>
        <span class="leave-confirm-modal__content">{{ content }}</span>
        <div class="leave-confirm-modal__actions">
          <div
            class="leave-confirm-modal__btn leave-confirm-modal__btn--leave"
            @click="onLeave"
          >
            {{ leaveText }}
          </div>
          <div
            class="leave-confirm-modal__btn leave-confirm-modal__btn--stay"
            @click="onStay"
          >
            {{ stayText }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 离开确认挽留弹窗
 *
 * - 纯展示：传 visible，监听 @leave / @stay
 * - 拦截返回：interceptBack=true 时组件自行 pushState + popstate
 */
export default {
  name: "LeaveConfirmModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "确认要离开",
    },
    content: {
      type: String,
      default: "完成基本信息填写，即可领取额度",
    },
    leaveText: {
      type: String,
      default: "离开",
    },
    stayText: {
      type: String,
      default: "再看看",
    },
    /** 弹窗背景图，默认 tl12 pop_bg */
    bgSrc: {
      type: String,
      default: "",
    },
    /** 是否拦截浏览器返回 */
    interceptBack: {
      type: Boolean,
      default: false,
    },
    /** true 时放行返回（父页确认离开后置 true） */
    allowLeave: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      backBound: false,
      defaultBgSrc: require("../../../public/img/register/register_tl12/pop_bg.png"),
    };
  },
  computed: {
    resolvedBgSrc() {
      return this.bgSrc || this.defaultBgSrc;
    },
  },
  watch: {
    allowLeave(val) {
      if (val) {
        this.unbindBack();
      }
    },
    interceptBack: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$nextTick(() => this.bindBack());
        } else {
          this.unbindBack();
        }
      },
    },
  },
  beforeDestroy() {
    this.unbindBack();
  },
  methods: {
    bindBack() {
      if (this.backBound || !this.interceptBack) {
        return;
      }
      window.history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.onPopState, false);
      this.backBound = true;
    },

    unbindBack() {
      if (!this.backBound) {
        return;
      }
      window.removeEventListener("popstate", this.onPopState, false);
      this.backBound = false;
    },

    onPopState() {
      if (this.allowLeave) {
        return;
      }
      // 压回 history，避免直接离开当前页
      window.history.pushState(null, null, document.URL);
      if (this.visible) {
        this.onStay();
        return;
      }
      this.$emit("update:visible", true);
      this.$emit("open");
    },

    onStay() {
      this.$emit("update:visible", false);
      this.$emit("stay");
    },

    onLeave() {
      this.$emit("update:visible", false);
      this.$emit("leave");
    },
  },
};
</script>

<style lang="scss" scoped>
.leave-confirm-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.leave-confirm-modal__mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.45);
}

.leave-confirm-modal__panel {
  position: relative;
  z-index: 1;
  width: 6rem;
  height: 3.44rem;
  box-sizing: border-box;
}

.leave-confirm-modal__bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 6rem;
  height: 3.44rem;
  z-index: 0;
}

.leave-confirm-modal__body {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0.48rem 0.4rem 0.4rem;
  box-sizing: border-box;
}

.leave-confirm-modal__title {
  font-size: 0.32rem;
  color: #202020;
  line-height: 1.4;
  margin-bottom: 0.16rem;
}

.leave-confirm-modal__content {
  font-size: 0.28rem;
  color: #666666;
  line-height: 1.5;
  flex: 1;
}

.leave-confirm-modal__actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.24rem;
}

.leave-confirm-modal__btn {
  width: 2.2rem;
  height: 0.8rem;
  line-height: 0.8rem;
  border-radius: 0.4rem;
  font-size: 0.28rem;
  font-weight: 500;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
}

.leave-confirm-modal__btn--leave {
  border: 0.01rem solid #999999;
  background: #ffffff;
  color: #202020;
}

.leave-confirm-modal__btn--stay {
  background: #678cf9;
  color: #ffffff;
}
</style>
